import { mdiDelete } from "@mdi/js";
import Icon from "@mdi/react";
import { getFileType } from "../../../purchase_order/model/purchase_order_model";
import FileDropZone from "../../../../ui/new_components/common/file_drop_zone";
import { FunctionComponent, useEffect, useState } from "react";
import { CustomerAttachmentModel } from "../../../../context_providers/auth/user_model";
import { FileType } from "../../../../utils/enums";
export const attachment_category = {
  aadhar: "Aadhar",
  pan: "PAN",
  other: "Other",
};
interface MultiAttachmentSectionProps {
  attachments?: CustomerAttachmentModel[];
  category: string;
  onSubmit: (data: {
    file: File;
    category: string;
  }) => Promise<CustomerAttachmentModel>;
  onDelete: (data: CustomerAttachmentModel) => void;
  id_prefix?: string;
}

const MultiAttachmentSection: FunctionComponent<MultiAttachmentSectionProps> = (
  props
) => {
  const [files, setFiles] = useState<CustomerAttachmentModel[]>(
    props.attachments || []
  );
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    setFiles(props.attachments || []);
  }, [props.attachments]);

  const handleFileDrop = async (droppedFiles: File[]) => {
    setUploading(true);
    for (const file of droppedFiles) {
      try {
        const uploadedFile = await props.onSubmit({
          file,
          category: props.category,
        });
        setFiles((prevFiles) => [...prevFiles, uploadedFile]);
      } catch (error) {
        console.error("File upload failed", error);
      }
    }
    setUploading(false);
  };

  const removeFile = (file: CustomerAttachmentModel) => {
    props.onDelete(file);
    setFiles((prevFiles) => prevFiles.filter((f) => f.id !== file.id));
  };

  const idPrefix = props.id_prefix ?? "multi-attachment";

  return (
    <div id={`${idPrefix}-section`} className="p-5">
      <div className="mb-4 relative">
        {uploading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75">
            Uploading...
          </div>
        )}
        <FileDropZone id={`${idPrefix}-file-input`} onDrop={handleFileDrop} />
      </div>

      <div className="space-y-4 max-h-96 overflow-y-auto">
        {files.map((fileObj, index) => (
          <div
            key={fileObj.id}
            id={`${idPrefix}-file-${index}`}
            className="flex items-center justify-between p-3 border rounded-md"
          >
            <div className="flex items-center gap-3">
              {getFileType(fileObj.type) === FileType.IMAGE ? (
                <img
                  src={fileObj.url}
                  alt={""}
                  className="w-16 h-16 object-cover"
                />
              ) : (
                <a
                  href={fileObj.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm"
                >
                  {fileObj.url}
                </a>
              )}
            </div>
            <button
              id={`${idPrefix}-file-delete-btn-${index}`}
              onClick={() => removeFile(fileObj)}
              className="p-2 bg-red-500 text-white rounded-full"
            >
              <Icon path={mdiDelete} size={0.8} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiAttachmentSection;
